/* eslint-disable jsx-a11y/no-redundant-roles */
import React, { useEffect } from "react";
import ScrollReveal from "scrollreveal";
import fortified_roof from "../../assets/images/services/fortified-roof.jpg";

export default function Example() {
  useEffect(() => {
    if (typeof window !== "undefined") {
      const sr = ScrollReveal({ reset: false });

      // reveal the section heading and title
      sr.reveal("#fortified p, #fortified h1", {
        origin: "left",
        distance: "20px",
        duration: 600,
        interval: 150,
      });

      // reveal the two descriptive paragraphs
      sr.reveal("#fortified .mt-10 p", {
        origin: "bottom",
        distance: "20px",
        duration: 600,
        interval: 150,
        delay: 200,
      });

      // reveal the roof image
      sr.reveal("#fortified img", {
        origin: "bottom",
        distance: "40px",
        duration: 800,
        delay: 400,
      });
    }
  }, []);

  return (
    <div id="fortified" className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-none">
          <p className="font-united_sans_sm text-base/7 font-semibold text-[#D2B48C]">
            FORTIFY YOUR ROOF
          </p>
          <h1 className="font-united_sans_lg mt-2 text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
            IBHS Fortified Roof & Fortified Roof Program
          </h1>
          <div className="mt-10 grid max-w-xl grid-cols-1 gap-8 text-base/7 text-gray-700 lg:max-w-none lg:grid-cols-2">
            <div>
              <p>
                The IBHS (Insurance Institute for Business & Home Safety)
                Fortified Roof is designed to provide superior protection
                against extreme weather conditions, including hurricanes, high
                winds, and heavy rain. By utilizing reinforced materials and
                advanced installation techniques, a FORTIFIED™ Roof
                significantly reduces the risk of storm-related damage, helping
                homeowners avoid costly repairs and insurance claims.
              </p>
            </div>
            <div>
              <p>
                The FORTIFIED™ Roof Program follows a set of rigorous standards
                developed by IBHS to strengthen roofs beyond typical building
                code requirements. This program ensures that roofs are built or
                upgraded with enhanced sealing, stronger fasteners, and
                impact-resistant materials to withstand severe weather.
                Homeowners who upgrade to a FORTIFIED™ Roof may also benefit
                from insurance discounts and financial incentives.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="relative overflow-hidden pt-16 lg:pt-20">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <img
            alt=""
            src={fortified_roof}
            className="block mx-auto mb-[-12%] rounded-xl shadow-2xl ring-1 ring-gray-900/10"
          />
          <div aria-hidden="true" className="relative">
            <div className="absolute -inset-x-20 bottom-0 bg-gradient-to-t from-white pt-[7%]" />
          </div>
        </div>
      </div>
    </div>
  );
}
